(() => {
  const WHITE_CHANNEL_MIN = 253;

  const parseRgb = (value) => {
    const match = String(value || '').match(/rgba?\(([^)]+)\)/i);
    if (!match) return null;

    const parts = match[1]
      .replace(/\//g, ' ')
      .split(/[\s,]+/)
      .filter(Boolean)
      .map(Number);

    if (parts.length < 3 || parts.slice(0, 3).some(Number.isNaN)) return null;

    return {
      r: parts[0],
      g: parts[1],
      b: parts[2],
      a: parts.length > 3 && !Number.isNaN(parts[3]) ? parts[3] : 1,
    };
  };

  const isVisibleColor = (value) => {
    const rgb = parseRgb(value);
    return rgb && rgb.a > 0;
  };

  const isWhite = (value) => {
    const rgb = parseRgb(value);
    if (!rgb || rgb.a <= 0) return false;

    return rgb.r >= WHITE_CHANNEL_MIN && rgb.g >= WHITE_CHANNEL_MIN && rgb.b >= WHITE_CHANNEL_MIN;
  };

  const visibleBackground = (section) => {
    const backgroundLayer = section.previousElementSibling?.classList.contains('section-background')
      ? section.previousElementSibling
      : null;

    if (backgroundLayer) {
      const background = getComputedStyle(backgroundLayer).backgroundColor;
      if (isVisibleColor(background)) return background;
    }

    const sectionBackground = getComputedStyle(section).backgroundColor;
    if (isVisibleColor(sectionBackground)) return sectionBackground;

    let parent = section.parentElement;
    while (parent) {
      const background = getComputedStyle(parent).backgroundColor;
      if (isVisibleColor(background)) return background;
      parent = parent.parentElement;
    }

    return 'rgb(255, 255, 255)';
  };

  const setCardSurfaces = (target, background) => {
    target.style.setProperty(
      '--brx-card-media-surface',
      isWhite(background) ? 'var(--brx-media-background)' : 'var(--brx-white)'
    );
    target.style.setProperty('--brx-card-dock-surface', background);
  };

  const applySurface = (section) => {
    if (!section?.querySelector('.product-card')) return;

    setCardSurfaces(section, visibleBackground(section));
  };

  const applyAll = (scope = document) => {
    const sections = scope.matches?.('.section')
      ? [scope]
      : [...scope.querySelectorAll?.('.section') || []];

    sections.forEach(applySurface);

    const looseCards = scope.querySelectorAll?.('.product-card:not(.section .product-card)') || [];
    looseCards.forEach((card) => {
      let parent = card.parentElement;
      let background = 'rgb(255, 255, 255)';

      while (parent) {
        const candidate = getComputedStyle(parent).backgroundColor;
        if (isVisibleColor(candidate)) {
          background = candidate;
          break;
        }
        parent = parent.parentElement;
      }

      setCardSurfaces(card, background);
    });
  };

  const init = () => applyAll(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => applyAll(event.target));
})();
